import storefront from "./storefront.svg";

export default function StorefrontIcon() {
  return (
    <img src={storefront} />
  );
}